import { useState, useRef } from "react";
import { Form, useSubmit, useOutletContext } from "react-router-dom";
import Wrapper from "../../assets/wrappers/DashboardFormPage";
import {
  Loading,
  FormRow,
  FormRowSelect,
  FormRowSelectId,
  NavLinkButton,
} from "../../components";
import {
  RSS_NEWS,
  WORK_ON_SATURDAY,
  MEMBER_TYPE,
  SORT_BY,
} from "../../../../utils/constants.js";
import { useAllOfficesContext } from "../../pages/AllOfficeBuildings.jsx"; // קונטקסט חדש!
import { useLocation } from "react-router-dom";

const OfficeBuildingSearchContainer = () => {
  const submit = useSubmit();
  const { user } = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const { maintenanceCompanies, cities } = useAllOfficesContext();
  const qs = new URLSearchParams(useLocation().search);

  const formRef = useRef(null);
  const debounceTimeout = useRef(null);

  const handleSelectChange = (fieldName) => {
    return (e) => {
      let formElement;

      if (e && e.target) {
        formElement = e.currentTarget.form;
      } else {
        formElement = formRef.current;
      }

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      const baseDelay = 100;
      debounceTimeout.current = setTimeout(async () => {
        setIsLoading(true);
        try {
          await submit(formElement);
        } catch (err) {
        } finally {
          setIsLoading(false);
        }
      }, baseDelay);
    };
  };

  const handleSearchChange = (e) => {
    const formElement = e.currentTarget.form;

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    const totalDelay = 1100;
    debounceTimeout.current = setTimeout(async () => {
      setIsLoading(true);
      try {
        await submit(formElement);
      } catch (err) {
      } finally {
        setIsLoading(false);
      }
    }, totalDelay);
  };

  return (
    <Wrapper>
      <Form className="form" ref={formRef}>
        <h5 className="form-title">חיפוש בניין משרדים</h5>

        {isLoading && <Loading />}

        <div className="form-center">
          <FormRow
            name="search"
            type="search"
            placeholder="חיפוש כינוי למשרד"
            labelText="חיפוש"
            defaultValue={qs.get("search") || ""}
            handleChange={handleSearchChange}
          />

          <FormRowSelect
            labelText="תחומי החדשות שיופיעו בכתוביות"
            name="rssTitleNewsPath"
            defaultValue={qs.get("rssTitleNewsPath") || "הכל"}
            list={[...Object.values(RSS_NEWS), "הכל"]}
            handleChange={handleSelectChange("rssTitleNewsPath")}
          />

          <FormRowSelect
            labelText="פעילות בשבת"
            name="workOnSaturday"
            list={[...Object.values(WORK_ON_SATURDAY), "הכל"]}
            defaultValue={qs.get("workOnSaturday") || "הכל"}
            handleChange={handleSelectChange("workOnSaturday")}
          />

          <FormRowSelect
            labelText="עיר"
            name="city"
            list={["הכל", ...cities.map((c) => c.city)]}
            defaultValue={qs.get("city") || "הכל"}
            handleChange={handleSelectChange("city")}
          />

          {qs.get("city") !== "הכל" && (
            <FormRowSelect
              labelText="רחוב"
              name="street"
              list={[
                "הכל",
                ...(cities
                  .find((c) => c.city === qs.get("city"))
                  ?.streets.map((s) => s.street) || []),
              ]}
              defaultValue={qs.get("street") || "הכל"}
              handleChange={handleSelectChange("street")}
            />
          )}

          <FormRowSelect
            labelText="מיון עיר לפי"
            name="sort"
            list={Object.values(SORT_BY)}
            defaultValue={qs.get("sort") || "newest"}
            handleChange={handleSelectChange("sort")}
          />

          {user.role === "admin" && maintenanceCompanies &&  (
            <FormRowSelectId
              labelText="חברת אחזקה"
              name="maintenanceCompany"
              list={maintenanceCompanies}
              idField="_id"
              displayField="name"
              defaultValue={qs.get("maintenanceCompany") || "הכל"}
              handleChange={handleSelectChange("maintenanceCompany")}
            />
          )}

          <NavLinkButton
            text="ניקוי סינון"
            path="/dashboard/all-office-buildings"
            icon="clear"
            color="#758694"
          />
        </div>
      </Form>
    </Wrapper>
  );
};

export default OfficeBuildingSearchContainer;
